class IconManager {
  // Un nom d'icône arrive sous 3 formes possibles ("check", "fa-check" ou "fa-solid fa-check") -
  // ne conserve que le nom nu pour composer ensuite un nom d'icône valide en 'fa-light fa-' + ce nom nu.
  parseIconName(value) {
    if (!value) {
      return "";
    }
    return String(value)
      .trim()
      .replace(/^(fa-(solid|regular|light|thin|duotone|brands)|fa[srltdb])\s+/i, "")
      .replace(/^fa-/i, "");
  }
}

export const iconManager = new IconManager();
